import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const MedicareMedicaidPage: React.FC = () => {
  const { getImage } = useImages();
  const medicalAlertImage = getImage('2016-03-14-02.49.24 (1).jpg');
  const medicareInfoImage = getImage('6793815283-2068c46b46-b.jpg');
  const discountsImage = getImage('6355840185-8e1c4d8f11-b.jpg');

  return (
    <div className="medicare-medicaid-page">
      {/* Hero Section */}
      <section className="medicare-medicaid-hero-section">
        <div className="medicare-medicaid-hero-container">
          <h1 className="medicare-medicaid-hero-title">
            Does Medicaid Cover Medical Alert Systems?
          </h1>
          
          <p className="medicare-medicaid-hero-text">
            Those in need of emergency response systems may wonder: does Medicaid cover medical alert systems? Currently, we are not able to accept Medicare, Medicaid, or any insurance as payment. We encourage our members to contact their health insurance provider to see if their plan will issue a reimbursement for a medical alert system.
          </p>
          
          <Link to="/medical-alerts" className="medicare-medicaid-shop-btn">
            SHOP AFFORDABLE ALERTS
          </Link>
        </div>
      </section>

      {/* How Can You Pay Section */}
      <section className="medicare-medicaid-payment-section medicare-medicaid-payment-section-gray">
        <div className="medicare-medicaid-hero-container">
          <h2 className="medicare-medicaid-section-title">How Can You Pay?</h2>
          
          <p className="medicare-medicaid-section-text">
            Alert1 accepts payment from credit cards, debit cards, and checks through automatic withdrawal. We accept Visa, MasterCard, and Discover. Those asking, <em>"Does Medicaid cover medical alert systems?"</em> should know that most PERS providers do not accept payment directly through any insurance plan.
          </p>
          
          <p className="medicare-medicaid-section-text">
            While we cannot accept Medicaid, we want to make your experience with us as good as possible. Ordering a medical alert system is simple. Call our Sales Representatives at 1-800-693-5433 or{' '}
            <Link to="/medical-alerts" style={{ color: '#0066cc', textDecoration: 'underline' }}>
              order securely online
            </Link>
            .
          </p>
          
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/medical-alerts" className="medicare-medicaid-order-btn">
              ORDER NOW
            </Link>
          </div>
        </div>
      </section>

      {/* Alert1 Medical Alert Systems Section */}
      <section className="medicare-medicaid-systems-section">
        <div className="medicare-medicaid-hero-container">
          <h2 className="medicare-medicaid-section-title">Alert1 Medical Alert Systems</h2>
          
          <div className="medicare-medicaid-systems-wrapper">
            <div className="medicare-medicaid-systems-content">
              <p className="medicare-medicaid-section-text">
                As seniors age, they need assurance that they will receive help in a medical emergency. Medical alert systems are designed to give seniors this security. Our systems are connected through home landlines, cellular, or GPS technology to cover seniors wherever they go. Alert1 offers both home and mobile alert systems to fit your needs. These devices can include fall detection, which senses a fall and contacts emergency services in case the senior is unable to.
              </p>
              
              <p className="medicare-medicaid-section-text">
                Alert1 provides monthly or annual plans to accommodate our member's financial needs. The monthly plan gives the member the ability to sign up for our program without feeling locked into a contract. So, while those asking, <em>"Does Medicaid cover medical alert systems?"</em> may be disappointed with their findings, know that we work with our users to find a solution to suit their budgets.
              </p>
            </div>
            
            <div className="medicare-medicaid-systems-image">
              {medicalAlertImage ? (
                <img 
                  src={medicalAlertImage} 
                  alt="Medical alert device" 
                  style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                />
              ) : (
                <div style={{ width: '100%', height: '300px', backgroundColor: '#f0f0f0', borderRadius: '8px' }} />
              )}
            </div>
          </div>
          
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/medical-alerts" className="medicare-medicaid-shop-btn">
              SHOP BEST PRICED ALERTS
            </Link>
          </div>
        </div>
      </section>

      {/* What to Know about Medicaid Section */}
      <section className="medicare-medicaid-systems-section medicare-medicaid-systems-section-gray">
        <div className="medicare-medicaid-hero-container">
          <h2 className="medicare-medicaid-section-title">What to Know about Medicaid</h2>
          
          <div className="medicare-medicaid-systems-wrapper">
            <div className="medicare-medicaid-systems-content">
              <p className="medicare-medicaid-section-text">
                Seniors aged 65 and older can qualify for{' '}
                <a href="https://www.medicare.gov" target="_blank" rel="noopener noreferrer" style={{ color: '#0066cc', textDecoration: 'underline' }}>
                  Medicare
                </a>
                . This is the federal health insurance program that covers a variety of health care expenses. There are different parts to Medicare that cover different services.
              </p>
              
              <p className="medicare-medicaid-section-text">
                <strong>Medicare Part A</strong> covers inpatient hospital stays, care in a nursing facility, hospice care, and some home health care. <strong>Medicare Part B</strong> covers certain doctors' services, outpatient care, medical supplies, and preventive services. <strong>Medicare Part C</strong> is a private health insurance plan that contains services from Part A, Part B, and additional benefits. <strong>Medicare Part D</strong> is optional prescription drug coverage.
              </p>
              
              <p className="medicare-medicaid-section-text">
                Medical alert systems are not typically covered by Part A or Part B, Medicare. Certain Medicare Part C plans may cover medical alert systems in special circumstances.
              </p>
            </div>
            
            <div className="medicare-medicaid-systems-image">
              {medicareInfoImage ? (
                <img 
                  src={medicareInfoImage} 
                  alt="Healthcare costs and savings" 
                  style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                />
              ) : (
                <div style={{ width: '100%', height: '300px', backgroundColor: '#f0f0f0', borderRadius: '8px' }} />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Long-Term Care Insurance Section */}
      <section className="medicare-medicaid-payment-section">
        <div className="medicare-medicaid-hero-container">
          <h2 className="medicare-medicaid-section-title">Long-Term Care Insurance</h2>
          
          <p className="medicare-medicaid-section-text">
            If you have supplemental long-term care insurance, you may qualify for reimbursements on your medical alert service.
          </p>
          
          <p className="medicare-medicaid-section-text">
            This type of insurance helps pay cost of long-term care for aging seniors. The insurance covers care not typically covered by Medicare, Medicaid or employer health insurance.
          </p>
          
          <p className="medicare-medicaid-section-text">
            Long-term care insurance policies reimburse policyholders a daily amount to pay for care services and supports in the home, a community organization, or other facilities.
          </p>
          
          <p className="medicare-medicaid-section-text">
            Check with your insurance provider to see if you qualify for coverage.
          </p>
        </div>
      </section>

      {/* Medical Alert Discounts Section */}
      <section className="medicare-medicaid-systems-section medicare-medicaid-systems-section-gray">
        <div className="medicare-medicaid-hero-container">
          <h2 className="medicare-medicaid-section-title">Medical Alert Discounts</h2>
          
          <div className="medicare-medicaid-systems-wrapper">
            <div className="medicare-medicaid-systems-content">
              <p className="medicare-medicaid-section-text">
                If you cannot afford a medical alert system, and your health insurance provider does not offer reimbursements, there are a variety of funding assistance options for our members.
              </p>
              
              <p className="medicare-medicaid-section-text">
                Users who are veterans, AARP or AAA members can receive discounts on their monthly service charge. Alert1 also offers a refer-a-friend discount. For every friend referred to Alert1, you receive a free month of service. As soon as they sign up, you both receive your free month. Learn more at our{' '}
                <Link to="/refer-friend" style={{ color: '#0066cc', textDecoration: 'underline' }}>
                  refer a friend page
                </Link>
                .
              </p>
              
              <p className="medicare-medicaid-section-text">
                Members who wish to add a spouse, partner, or an additional user may receive a deal on their service. A second additional user can be added for 50% off the original charge.
              </p>
            </div>
            
            <div className="medicare-medicaid-systems-image">
              {discountsImage ? (
                <img 
                  src={discountsImage} 
                  alt="Save money with discounts" 
                  style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                />
              ) : (
                <div style={{ width: '100%', height: '300px', backgroundColor: '#f0f0f0', borderRadius: '8px' }} />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Get Protection Today Section */}
      <section className="medicare-medicaid-payment-section">
        <div className="medicare-medicaid-hero-container">
          <h2 className="medicare-medicaid-section-title">Get Protection Today</h2>
          
          <p className="medicare-medicaid-section-text">
            We hope you decide to join the Alert1 family. Maintain your independence and stay protected. Alert1 is the preparation you need in the event of an emergency. Help is just a push of a button away.
          </p>
          
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Link to="/medical-alerts" className="medicare-medicaid-order-btn" style={{ textDecoration: 'underline' }}>
              GET PROTECTION NOW
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MedicareMedicaidPage;
